module.exports = __webpack_public_path__ + "64ecfb17b598686687f47780ae8e9dee.svg";